module.exports = __webpack_public_path__ + "img/img18.c03e31d4.png";